exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table[data-v-6bd6a19a]{line-height:1.3;margin:calc(-.5rem - 1px);border-collapse:collapse;border-spacing:0;table-layout:fixed;border-bottom:1px solid rgba(0,0,0,.05);border-right:1px solid rgba(0,0,0,.05)}.cell[data-v-6bd6a19a]{width:7.5rem;font-size:.8125rem;font-weight:400;vertical-align:middle;padding:.5rem;border:1px solid rgba(0,0,0,.05);text-align:center;word-wrap:break-word}", ""]);

// exports
